import * as actions from 'actions';
import { persistEmailsSettings, getGenericEmails, getEmailsSettings, persistGenericEmail, sendTestEmails, getOrganisationEmailsSettings, resetCurrentGenericEmail } from 'TamtamAPI';
import { ucFirst } from '../../../services/utils';

export const saveEmailsSettings = (action = null, extraData = null) => {
  return (dispatch, getState) => {
    const { token, currentClient } = getState().auth;
    const { emails, ...data } = getState().genericEmail.currentSetting;

    if (action) {
      data['action'] = action;
    }

    if (extraData) {
      Object.assign(data, extraData);
    }

    if (data.targetApp === "PAYMENT" && ["EVENT_REMINDER", "EVENT_REVIVAL"].indexOf(data.target.id) > -1){
      data.types = data.types.filter(function (type) {
        if (data.target.id === "EVENT_REVIVAL") {
          return type.id.search("RELANCE") > -1
        } else {
          return type.id.search("RELANCE") < 0
        }
      });
    }

    data['organization'] = currentClient.id;
    return dispatch(actions.saveEmailsSettings(
      persistEmailsSettings(token, data)
    ));
  };
};

const bumpRank = (type) => ({
  ...type,
  rank: (parseInt(type.rank, 10) || 0) + 1,
});

export const addTypesToCurrentSetting = (newTypes = []) => {
  return (dispatch, getState) => {
    const { types } = getState().genericEmail.currentSetting;
    const existingIds = (types || []).map((type) => type.id);
    // New types are pinned to rank 0 (on top); the existing ones shift down +1.
    const typesToAdd = newTypes
      .filter((type) => existingIds.indexOf(type.id) < 0)
      .map((type) => ({ ...type, rank: 0 }));
    const bumped = (types || []).map(bumpRank);

    const mergedTypes = [...typesToAdd, ...bumped].sort(
      (a, b) => (a.rank > b.rank ? 1 : -1)
    );

    dispatch(actions.setCurrentEmailingSetting({ types: mergedTypes }));
    return dispatch(saveEmailsSettings());
  };
};

export const updateTypeInCurrentSetting = (updatedType) => {
  return (dispatch, getState) => {
    const { types, targetApp } = getState().genericEmail.currentSetting;
    // The modified type goes back to rank 0 (on top); every other type +1.
    const mergedTypes = (types || [])
      .map((type) =>
        type.id === updatedType.id
          ? { ...type, ...updatedType, rank: 0 }
          : bumpRank(type)
      )
      .sort((a, b) => (a.rank > b.rank ? 1 : -1));

    dispatch(actions.setCurrentEmailingSetting({ types: mergedTypes }));
    // Tell the backend exactly which type identity was edited.
    const syncTypes = [
      { id: updatedType.id, targetApp: updatedType.targetApp || targetApp },
    ];
    return dispatch(saveEmailsSettings(null, { syncTypes }));
  };
};

export const removeTypeFromCurrentSetting = (typeId) => {
  return (dispatch, getState) => {
    const { types } = getState().genericEmail.currentSetting;
    const mergedTypes = (types || []).filter((type) => type.id !== typeId);

    dispatch(actions.setCurrentEmailingSetting({ types: mergedTypes }));
    return dispatch(saveEmailsSettings());
  };
};

export const fetchEmailSettings = (filter) => {
  return (dispatch, getState) => {
    const { token, currentClient: { id } } = getState().auth;

    const data = { organization: id, ...filter };
    return dispatch(actions.fetchCurrentEmailingSetting(getEmailsSettings(token, data)));
  };
};

export const fetchGenericEmails = (filters) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(actions.fetchGenericEmails(getGenericEmails(token, filters)));
  };
};

export const saveCurrentGenericEmail = (data = {}) => {
  return (dispatch, getState) => {
    const { token, user } = getState().auth;
    const { currentSetting } = getState().genericEmail;
    data.updatedBy = user.id;
    let params = { ...currentSetting.currentEmail, ...data };

    const lng = ucFirst(params.language);
    const defaultTheme = currentSetting[`theme${lng}`];
    const currentTheme = params.theme;

    const hasDefaultTheme = currentTheme && currentTheme.id && defaultTheme && defaultTheme.id == currentTheme.id;
    if (hasDefaultTheme) {
      params.theme = null;
    }
    return dispatch(actions.saveCurrentGenericEmail(
      persistGenericEmail(token, params)
    ));
  };
};

export const sendGenericEmailTest = (data) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    return dispatch(actions.sendGenericEmailTest(
      sendTestEmails(token, data)
    ));
  };
};

export const fetchOrganisationEmailsSettings = () => {
  return (dispatch, getState) => {
    const { token, currentClient } = getState().auth;
    const { pageSize, paginationPage } = getState().genericEmail.settings;
    const { targetApp } = getState().genericEmail.settings.filter;
    const { status } = getState().genericEmail.settings.filter;

    return dispatch(actions.fetchOrganisationEmailsSettings(
      getOrganisationEmailsSettings(token, currentClient.id, status, pageSize, targetApp, paginationPage) //API TAMTAM
    ));
  };
};

export const resetGenericEmail = () => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { currentEmail } = getState().genericEmail.currentSetting;
    const { ...data } = currentEmail;
    return dispatch(actions.saveCurrentGenericEmail(
      resetCurrentGenericEmail(token, data.id)
    ));
  };
};
